module.exports = __webpack_public_path__ + "img/head-one.e55ddde5.png";